import { render, staticRenderFns } from "./AufgabenTemplatedPage.vue?vue&type=template&id=4b8f8b80"
import script from "./AufgabenTemplatedPage.vue?vue&type=script&lang=ts"
export * from "./AufgabenTemplatedPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports